import Loadable from 'components/@ui/loader/Loadable';
import { lazy } from 'react';
import { ROLES } from 'variables';

const Profile = Loadable(lazy(() => import('pages/profile-management/profile/Profile')));
const ProfileUpdate = Loadable(lazy(() => import('pages/profile-management/profile-update/ProfileUpdate')));

export const ProfileRoutes = [
  {
    path: '/profile',
    element: <Profile />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'account'
  },
  {
    path: '/profile/update',
    element: <ProfileUpdate />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'account'
  }
];
